__webpack_require__.p = "https://cdn.magiloop.com/dist/carizmamotors/";